export enum AccountTypeEnum {
  C = 'Corrente',
  P = 'Poupança',
  S = 'Pagamento'
}